<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Filter :button="filterConfig.buttonConfig" />

    <div class="table-data">
      <div v-if="loading" class="loading-indicator-report spinner-border spinner-border"></div>

      <table class="table table-hover table-responsive">
        <thead class="table-light">
          <tr>
            <th scope="col" width="30">
              <span class="d-flex justify-content-start">
              </span>

            </th>
            <th scope="col" width="140">ID</th>
            <th scope="col" width="180">Controller</th>
            <th scope="col" width="180">Physical ID</th>
            <th scope="col" width="180">Is Service Enabled</th>
            <th scope="col" width="120">Status</th>
            <th scope="col">Started On</th>
            <th scope="col">
              <span class="d-flex justify-content-end">
                <tableHeadingIcon />
              </span>

            </th>

          </tr>
        </thead>
        <tbody v-for="(item, index) in tableData" :key="index">
          <tr>
            <td rowspan="2">
              <span class="d-flex justify-content-start">
                <button class="custom-dropdown-icon" @click="toggleCollapse(index)">
                  <svg v-if="isCollapsed[index]" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg>
                </button>
              </span>
            </td>
            <td>{{ item.controllerdata.id }}</td>
            <td>{{ item.controllerdata.title }}</td>
            <td>{{ item.systeminfo.physicalid }}</td>
            <td v-if="item.remoteservice.servicestatus === 'active'">Yes</td>
            <td v-else-if="item.remoteservice.servicestatus === 'inactive'">No</td>
            <td>{{ item.remoteservice.servicestatus }}</td>
            <td>{{ item.remoteservice.starttime }}</td>
            <td>
              <span class="d-flex justify-content-end">
                <router-link :to="`/remoteops/controller/view/${item.systeminfo.physicalid}`">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-opencollective" viewBox="0 0 16 16">
                    <path fill-opacity=".4"
                      d="M12.995 8.195c0 .937-.312 1.912-.78 2.693l1.99 1.99c.976-1.327 1.6-2.966 1.6-4.683 0-1.795-.624-3.434-1.561-4.76l-2.068 2.028c.468.781.78 1.679.78 2.732z" />
                    <path
                      d="M8 13.151a4.995 4.995 0 1 1 0-9.99c1.015 0 1.951.273 2.732.82l1.95-2.03a7.805 7.805 0 1 0 .04 12.449l-1.951-2.03a5.07 5.07 0 0 1-2.732.781z" />
                  </svg>
                </router-link>

              </span>

            </td>

          </tr>
          <tr v-if="isCollapsed[index]">

            <td colspan="10" class="py-0 px-0">
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" width="150">Type</th>
                    <th scope="col" width="150">OS Name</th>
                    <th scope="col" width="150"> Version</th>
                    <th scope="col" width="150"> Last Installed</th>
                    <th scope="col" width="180"> Last Updated</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{ item.systeminfo.systemtype }}</td>
                    <td>{{ item.systeminfo.osname }}</td>
                    <td>{{ item.systeminfo.osversion }}</td>
                    <td>{{ item.systeminfo.systemlastinstalled }}</td>
                    <td>{{ item.systeminfo.systemlastupdated }}</td>
                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" width="150">Firmware Version</th>
                    <th scope="col" width="150">Firmware Type</th>
                    <th scope="col" width="150">Firmware Last Updated</th>

                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{ item.firmwaredetail.firmwareversion }}</td>
                    <td>{{ item.firmwaredetail.firmwaretype }}</td>
                    <td>{{ item.firmwaredetail.firmwarelastupdated }}</td>

                  </tr>
                </tbody>
              </table>
              <table class="table table-responsive sub-table mb-0">
                <thead class="table-light">
                  <tr>

                    <th scope="col" width="150">Total</th>
                    <th scope="col" width="150">Consumed</th>
                    <th scope="col" width="150">Available</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>{{ item.systemsize.totalsize }}</td>
                    <td>{{ item.systemsize.usedspace }}</td>
                    <td>{{ item.systemsize.availablespace }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-container">
        <div class="items-per-page">
          <label for="itemsPerPage">Records Per Page:</label>
          <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize" @change="changePageSize">
            <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
          </select>
        </div>
        <div class="total-entries">
          <span>Total Records: {{ totalCount }}</span>
        </div>
        <div class="pagination">
          <ul class="pagination-list">
            <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                  <path
                    d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                </svg></a></li>
            <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                </svg></a></li>
            <li v-for="pageNumber in visiblePages" :key="pageNumber" :class="{ active: pageNumber === currentPage }"
              class="ellipsis-icon" @click="gotoPage(pageNumber)">
              <template v-if="pageNumber === 'dots'">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-three-dots" viewBox="0 0 16 16">
                    <path
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                  </svg>
                </span>
              </template>
              <template v-else>
                <a>{{ pageNumber }}</a>
              </template>
            </li>

            <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                </svg></a></li>
            <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                  fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                  <path
                    d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                </svg></a></li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import tableHeadingIcon from '@/components/table-heading-icon.vue';
import { getServiceStatus } from "@/http/remote-ops/controller.http"
export default {
  name: "controller",
  components: {
    Header,
    Filter,
    tableHeadingIcon
  },
  data() {
    return {
      breadcrumsfirst: "Remote Ops",
      breadcrumslast: "Controller",
      filterConfig: {
        buttonConfig: {
          show: false,
          link: '/remoteops/controller/add'
        }
      },
      loading: false,
      tableData: [],
      remoteservice: {},
      systeminfo: {},
      firmwaredetail: {},
      systemsize: {},
      controllerdata: {},
      isCollapsed: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      pageSizeOptions: [10, 20], // Define your options for items per page
    };
  },
  created() {
    // Initialize isCollapsed with the correct length and set all elements to false
    this.isCollapsed = new Array(this.tableData.length).fill(false);
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const totalVisiblePages = 3; // Change this as needed
      const pages = [];
      let startPage = 1;
      let endPage = this.totalPages;

      if (this.totalPages > totalVisiblePages) {
        const halfVisiblePages = Math.floor(totalVisiblePages / 2);
        startPage = Math.max(this.currentPage - halfVisiblePages, 1);
        endPage = startPage + totalVisiblePages - 1;

        if (endPage > this.totalPages) {
          startPage -= endPage - this.totalPages;
          endPage = this.totalPages;
        }

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) {
            pages.push('dots');
          }
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < this.totalPages) {
        if (endPage < this.totalPages - 1) {
          pages.push('dots');
        }
        pages.push(this.totalPages);
      }

      return pages;
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      getServiceStatus({
        index: this.currentPage,
        pagesize: this.pageSize
      })
        .then(response => {
          this.tableData = response.servicedetail;
          this.totalCount = response.recordcount.totalcount;
          this.tableData.map((res) => {
            this.remoteservice = res.remoteservice
            this.systeminfo = res.systeminfo
            this.firmwaredetail = res.firmwaredetail
            this.systemsize = res.systemsize
            this.controllerdata = res.controllerdata
          })
          // this.totalCount = response.recordcount.totalcount;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        }).finally(() => {
          this.loading = false;
        })
    },
    gotoPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.fetchData();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData();
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.fetchData();
    },
    toggleCollapse(index) {
      this.isCollapsed[index] = !this.isCollapsed[index];
    }
  },
  mounted() {
    this.fetchData();
  }

};
</script>

<style>
.sub-table {
  border: transparent;
}

.custom-dropdown-icon {
  border: none;
  /* Remove the border */
  background: none;
  /* Remove background */
  cursor: pointer;
  /* Change cursor to pointer on hover */
  padding: 0;
  /* Remove padding */
  margin: 0;
  /* Remove margin */
}
</style>